import { useId, useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { getGlossaryTerm } from './payrollGlossary';

/** Inline help icon with definition on hover / focus. */
export default function HelpTip({ term, label, className = '' }) {
  const def = getGlossaryTerm(term);
  const [open, setOpen] = useState(false);
  const tipId = useId();

  if (!def) return null;

  return (
    <span className={`help-tip inline-flex items-center ${className}`.trim()}>
      <button
        type="button"
        className="help-tip-trigger"
        aria-label={`Help: ${def.title}`}
        aria-describedby={open ? tipId : undefined}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
      >
        <HelpCircle className="h-3.5 w-3.5" />
        {label ? <span className="sr-only">{label}</span> : null}
      </button>
      {open && (
        <span id={tipId} role="tooltip" className="help-tip-panel">
          <span className="block font-semibold text-slate-100">{def.title}</span>
          <span className="mt-1 block text-slate-300">{def.text}</span>
        </span>
      )}
    </span>
  );
}
